import { render, staticRenderFns } from "./McPaymentList.vue?vue&type=template&id=6af818ae&scoped=true&"
import script from "./McPaymentList.vue?vue&type=script&lang=js&"
export * from "./McPaymentList.vue?vue&type=script&lang=js&"
import style0 from "./McPaymentList.vue?vue&type=style&index=0&id=6af818ae&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6af818ae",
  null
  
)

export default component.exports